"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var temp = function CloseCircleTwoTone(primaryColor, secondaryColor) {
  return {
    name: 'close-circle',
    theme: 'twotone',
    nameWithTheme: 'close-circle-twotone',
    tag: 'svg',
    attrs: {
      xmlns: 'http://www.w3.org/2000/svg',
      class: 'icon',
      viewBox: '0 0 1024 1024'
    },
    children: [{
      tag: 'path',
      attrs: {
        fill: primaryColor,
        d: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        fill: secondaryColor,
        d: 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm171.8 527.1c1.2 1.5 1.9 3.3 1.9 5.2 0 4.5-3.6 8-8 8l-66-.3-99.3-118.4-99.3 118.5-66.1.3c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2L471 512.3l-130.1-155c-1.2-1.5-1.9-3.3-1.9-5.2 0-4.5 3.6-8 8-8l66.1.3 99.3 118.4 99.4-118.5 66-.3c4.4 0 8 3.6 8 8 0 1.9-.6 3.8-1.8 5.2l-130.1 155 129.9 154.9z'
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        fill: primaryColor,
        d: 'M685.8 352c0-4.4-3.6-8-8-8l-66 .3-99.4 118.5-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155-130.1 154.9c-1.2 1.5-1.9 3.3-1.9 5.2 0 4.4 3.6 8 8 8l66.1-.3 99.3-118.5L611.7 680l66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.9 512.2l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z'
      },
      children: []
    }]
  };
};
temp.nameWithTheme = 'close-circle-twotone';
var CloseCircleTwoTone = temp;
exports.default = CloseCircleTwoTone;